import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { RestOperatorsService } from "./rest-operators.service";

@Injectable()
export class RestService {
    constructor(
        private _http: Http,
        private _restOperationsService: RestOperatorsService
    ) {}

    onPost(route:string, object:any, done: any) {
        var arg: string = '/inserir';
        var apiRoute: string = this._restOperationsService.getApiRoute(route, arg);
        var options = this._restOperationsService.getHeaderJson();

        object.ativo = true;
        object = JSON.stringify(object);

        var response = this._http
            .post(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        return this._restOperationsService.call(response, done);
    }

    onPostCustom(route:string, object:any, done: any) {
        var apiRoute: string = this._restOperationsService.getApiRoute(route, '');
        var options = this._restOperationsService.getHeaderJson();

        object = JSON.stringify(object);

        var response = this._http
            .post(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        return this._restOperationsService.call(response, done);
    }

    onPut(route:string, object:any, done:any) {
        var arg: string = '/editar/id/' + object.id;
        var apiRoute: string = this._restOperationsService.getApiRoute(route, arg);
        var options = this._restOperationsService.getHeaderJson();

        object = JSON.stringify(object);

        var response = this._http
            .put(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onPatch(route:string, object:any, done:any) {
        var apiRoute: string = this._restOperationsService.getApiRoute(route, '');
        var options = this._restOperationsService.getHeaderJson();

        object = JSON.stringify(object);

        var response = this._http
            .patch(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onDelete(route:string, objectId: number, done:any) {
        var arg: string = '/editar/id/' + objectId;
        var apiRoute: string = this._restOperationsService.getApiRoute(route, arg);
        var options = this._restOperationsService.getHeaderJson();

        var object:any = {ativo: false};
        object = JSON.stringify(object);

        var response = this._http
            .put(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onGet(route:string, done:any) {
        var apiRoute: string = this._restOperationsService.getApiRoute(route, '');
        var options = this._restOperationsService.getHeaderJson();

        var response = this._http
            .get(apiRoute, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onGetSemSchema(route:string, done:any) {
        var server_url: string = this._restOperationsService.server_url;
        var options = this._restOperationsService.getHeaderJson();

        var response = this._http
            .get(server_url + '/' + route, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onGetSemToken(route:string, done:any) {
        var schema: string = this._restOperationsService.getTenant();
        var server_url: string = this._restOperationsService.server_url;
        var options = this._restOperationsService.getHeaderJson();

        var response = this._http
            .get(server_url + '/' + route + '/' + schema, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onGetPost(route:string, object:any, done:any) {
        var arg: string = '/listar';
        var apiRoute: string = this._restOperationsService.getApiRoute(route, arg);
        var options = this._restOperationsService.getHeaderJson();

        object = JSON.stringify(object);

        var response: any = this._http
            .post(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onGetPostId(route:string, objectId:number, object:any, done:any) {
        var arg: string = '/id/' + objectId;
        var apiRoute: string = this._restOperationsService.getApiRoute(route, arg);
        var options = this._restOperationsService.getHeaderJson();

        object = JSON.stringify(object);

        var response: any = this._http
            .post(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    onGetPostCustom(route:string, object:any, done:any) {
        var apiRoute: string = this._restOperationsService.getApiRoute(route, '');
        var options = this._restOperationsService.getHeaderJson();

        object = JSON.stringify(object);

        var response: any = this._http
            .post(apiRoute, object, options)
            .map(this._restOperationsService.extractData)
            .catch(this._restOperationsService.handleError);

        this._restOperationsService.call(response, done);
    }

    getAutocompleteAjax(route:string, arg: string, method?: string) {
        var apiRoute: string = this._restOperationsService.getApiRoute(route, arg);

        if (!method) {
            method = 'POST';
        }

        var Ajax: any = {
            url: apiRoute,
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json',
            method: method,
            delay: 250,
            cache: true
        };

        return Ajax;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/services/rest.service.ts
 **/